(function () {
  // Only run on KISS Nails nav context
  if (!document.documentElement.classList.contains('nav--main-menu-kiss-nails')) return;

  const ICON_CLASS = 'kiss-js-plusminus';
  const EXCLUDE_SELECTOR = '.kiss-footer, .kiss-footer-bg';

  function findCaret(el) {
    return (
      el.querySelector('.icon-caret') ||
      el.querySelector('svg.icon-caret') ||
      el.querySelector('svg.icon.icon-caret')
    );
  }

  function ensurePlusMinus(details) {
    // skip footer areas
    if (details.closest(EXCLUDE_SELECTOR)) return;

    const summary = details.querySelector('summary');
    if (!summary) return;

    const caret = findCaret(summary);
    if (!caret) return; // only where caret exists

    // already processed
    if (summary.querySelector('.' + ICON_CLASS)) return;

    // hide original caret
    caret.style.display = 'none';

    // inject bar-style icon container
    const icon = document.createElement('span');
    icon.className = ICON_CLASS;
    icon.setAttribute('aria-hidden', 'true');
    summary.appendChild(icon);

    const update = () => {
      icon.classList.toggle('is-open', details.open);
    };

    update();
    details.addEventListener('toggle', update);
  }

  // --- Tab Collage (data-accordion) caret -> plus/minus ---
  function ensureTabCollageIcon(headingEl) {
    // skip footer areas
    if (headingEl.closest(EXCLUDE_SELECTOR)) return;

    const caret = findCaret(headingEl);
    if (!caret) return; // only headings that actually have caret

    // already processed
    if (headingEl.querySelector('.' + ICON_CLASS)) return;

    // hide original caret
    caret.style.display = 'none';

    // inject bar-style icon container
    const icon = document.createElement('span');
    icon.className = ICON_CLASS;
    icon.setAttribute('aria-hidden', 'true');
    headingEl.appendChild(icon);

    const update = () => {
      // tab-collage uses .is-active to represent open/selected
      icon.classList.toggle('is-open', headingEl.classList.contains('is-active'));
    };

    update();

    // watch for class changes (is-active toggles)
    const mo = new MutationObserver(update);
    mo.observe(headingEl, { attributes: true, attributeFilter: ['class'] });
  }

  function initTabCollage(scope = document) {
    // skip scanning inside footer areas
    scope.querySelectorAll('[data-accordion] .tab-collage__heading').forEach((heading) => {
      ensureTabCollageIcon(heading);
    });
  }

  function init(scope = document) {
    // Accordion / details-based
    scope.querySelectorAll('details').forEach((d) => {
      const inAccordion = d.closest('.accordion, accordion-tab, .product-details, .product__accordion');
      if (!inAccordion) return;
      ensurePlusMinus(d);
    });

    // Tab collage headings
    initTabCollage(scope);
  }

  init();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => init(e.target));

  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        init(node);
      }
    }
  });

  obs.observe(document.body, { childList: true, subtree: true });
})();
